import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";
import * as Html from "../util/Html.ts";

export{init}
Html.registerWidget('widget/user-picker',{init:init})

const updaters = {
  none:function(){},
  updateTextIm:function (obj,toAll,names){
    var text = i18n.get("labels.recipients")+ " ";
    if(toAll){
      text += i18n.get("new_message.all");
    }else{
      text += names.join(', ');
    }
    obj.find('p').last().text(text);
  },
  updateTextTask:function(obj,toAll,names){
    var text;
    if(toAll){
      text = i18n.get("task_details.assigntoall");
    }else if(names.length){
      text = i18n.get("task_details.assignto",names.join(', '));
    }else{
      text = i18n.get("task_details.assigntonobody");
    }
    obj.find('.label').first().text(text);
  },
  updateTextTaskList:function(obj,toAll,names){
    var text = i18n.get("catsystem.sharedwith")+names.map(n=>'<span class="color-branded">'+Html.escape(n)+'</span>').join(', ');
    obj.find('p').first().html(text);
  },
  updateTextBudget:function(obj,toAll,names){
    
  },
  updateTextTimetable:function(obj,toAll,names){
    var text = '<b>'+i18n.get("timetable.label.sharedwithusers")+'</b> '+Html.escape(names.join(', '));
    obj.find('p').first().html(text);
  },
  updateTextEvent:function (obj,toAll,names){
    var text = i18n.get("new_event.attendees")+": ";
    if(toAll){
      text += i18n.get("new_message.all");
    }else if(names.length===0){
      text += i18n.get("labels.none");
    }else{
      text += names.join(', ');
    }
    obj.find('p').first().text(text);
  }
}
function init(obj){
  var 
    textUpdater = obj.attr('data-textupdater')||'none', //method to update the first p
    initialValue = (obj.attr('data-value')||"").replace(/,$/,''),
    acceptEmpty = (obj.attr('data-acceptempty')||"true")==="true",
    useEmpty = obj.attr('data-useempty')==='true',
    imgs = obj.find('img'),
    familyNode = imgs.first().attr('data-accountId')?obj.find('nodethatdontexits'):imgs.first(),
    select =  obj.find('select'),
    toAllInput =  obj.find('input'),
    accountNode = obj.find('img[data-accountId]'),
    allAccountIds = accountNode.map(function(idx,node){
      return $(node).attr('data-accountId');
    }).toArray(),
    accountIds = initialValue===""?[]:(initialValue==="all"?allAccountIds:initialValue.split(','));
  
  obj.on('clear',function(){
    accountIds = [];
    refresh();
  })  
    
  function isAll(){
    return accountIds.length===allAccountIds.length;
  }
  
  function refresh(){
    if(isAll()){
      familyNode.addClass('selected');
      accountNode.addClass('selected');
    }else{
      familyNode.removeClass('selected');
      accountNode.each(function(idx,node){
        if(accountIds.indexOf($(node).attr('data-accountId'))>-1){
          $(node).addClass('selected');
        }else{
          $(node).removeClass('selected');
        }
      })
    }
    if(accountIds.length>0){
      var options = "";
      for(var i=0;i<accountIds.length;i++){
        options += '<option value="'+accountIds[i]+'" selected></option>'
      }
      select.html(options)
    }else if(useEmpty){
      select.html('<option value="$empty" selected></option>')
    }else{
      select.html('')
    }
    toAllInput.val(isAll());
    updaters[textUpdater](obj,isAll(),$.map(accountIds,function(accountId){
      return obj.find("img[data-accountId='"+accountId+"']").attr('title');
    }));
    select.trigger('change');

    obj.trigger('pickedaccounts',{
      accounts:accountIds.map(function(accountId,idx){
        return FwDatas.getProfile(accountId)
      }),
      isAll:isAll()
    });

  }
  
  setTimeout(refresh,50);
  accountNode.on('click',function(){
    var accountId = $(this).attr('data-accountId');
    if(isAll()){
      accountIds = [accountId];
    }else if(accountIds.indexOf(accountId)===-1){
      accountIds.push(accountId);
    }else if(accountIds.length>1 || acceptEmpty){
      accountIds.splice(accountIds.indexOf(accountId),1);
    }
     refresh();
  });
  familyNode.on('click',function(){
    if(isAll()){
      if(acceptEmpty){
        accountIds = [];
      }
    }else{
      accountIds = [].concat(allAccountIds);
    }
    refresh();
  });
}